import { NavLink } from './NavLink'
import { useLocale } from '@/i18n/locale'
import { TG_PERSONAL, TG_PERSONAL_URL } from '@/lib/contacts'

/**
 * Footer — «куда ещё можно уйти» + контакты и юридика.
 *
 * Раньше он повторял верхнее меню, но другими словами: «Как работаем»
 * вело на #ladder (то есть на стоимость), «DNAI-метод» — на ту же
 * методологию, что и в шапке, «Кейсы» и «Материалы» дублировались один
 * в один. Получались два разных оглавления одного и того же — и ни одно
 * не совпадало с другим (мандат Тони 2026-08-03: «нужна единая логика»).
 *
 * Роли разведены:
 *   шапка  — маршрут ПО ГЛАВНОЙ (якоря) плюс «Материалы»;
 *   футер  — то, чего в шапке нет: отдельные страницы, контакт, юридика,
 *            и «наверх» вместо якорей, мимо которых человек уже прокрутил.
 *
 * Дублировать якоря внизу бессмысленно: до футера долистал тот, кто эти
 * секции уже проехал. Ссылка на pillar остаётся сквозной — она даёт хабу
 * внутренний вес с каждой страницы сайта.
 *
 * На /en ru-only страницы скрыты, чтобы не выкидывать англоязычного
 * посетителя на русскую (см. LOCALIZED_PATHS в src/i18n/locale.ts).
 */
export function Footer() {
  const isEn = useLocale() === 'en'
  return (
    <footer className="border-t border-divider py-12">
      <div className="container-x flex flex-col gap-6">
        {/* Ссылки блоков лендинга */}
        <div
          id="club"
          className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-small text-muted"
        >
          {/* Только отдельные страницы — ни одного якоря из шапки. */}
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {isEn ? (
              <>
                <NavLink href="/en/ai-implementation" className="text-muted hover:text-ink no-underline">
                  AI implementation
                </NavLink>
                <NavLink href="#top" className="text-muted hover:text-ink no-underline">
                  Back to top
                </NavLink>
              </>
            ) : (
              <>
                {/* Sitewide-ссылка на pillar «внедрение ии» — топикальная
                    авторитетность: хаб получает внутренний вес с каждой
                    страницы. RU-only (страница пока не переведена). */}
                <NavLink href="/vnedrenie-ii-agentov" className="text-muted hover:text-ink no-underline">
                  Внедрение ИИ
                </NavLink>
                <NavLink href="/keysy" className="text-muted hover:text-ink no-underline">
                  Кейсы
                </NavLink>
                <NavLink href="/faq" className="text-muted hover:text-ink no-underline">
                  Вопросы и ответы
                </NavLink>
                <NavLink href="/guides" className="text-muted hover:text-ink no-underline">
                  Гайды
                </NavLink>
                {/* /developer — отраслевая страница для застройщиков (статика из
                    public/); до футера на неё не вело ни одной ссылки.
                    Слэш в конце — как в sitemap. */}
                <NavLink href="/developer/" className="text-muted hover:text-ink no-underline">
                  ИИ для девелоперов
                </NavLink>
                <NavLink href="/author/anton-robaten" className="text-muted hover:text-ink no-underline">
                  Об авторе
                </NavLink>
                <NavLink href="#top" className="text-muted hover:text-ink no-underline">
                  Наверх
                </NavLink>
              </>
            )}
          </div>
          <NavLink
            href="#final-cta"
            className="text-ink hover:opacity-70 no-underline font-medium"
          >
            {isEn ? 'AI diagnostics →' : 'ИИ-диагностика →'}
          </NavLink>
        </div>

        {/* Юридика + контакты + расшифровка DNAI */}
        <div className="pt-6 border-t border-divider flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-small text-muted">
          <div>
            <span className="text-ink">DNAI Engineering</span>
            {isEn
              ? ' — AI engineering and architecture for business · Anton Ro Baten'
              : ' — ИИ-инжиниринг и архитектура для бизнеса · ИП Ро Батень А.С.'}
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <a
              href={TG_PERSONAL_URL}
              target="_blank"
              rel="noreferrer"
              className="text-muted hover:text-ink no-underline"
            >
              t.me/{TG_PERSONAL}
            </a>
            <NavLink href={isEn ? '#top' : '/'} className="text-muted hover:text-ink no-underline">
              dnai.engineering
            </NavLink>
            {!isEn && (
              <NavLink href="/privacy" className="text-muted hover:text-ink no-underline">
                Политика конфиденциальности
              </NavLink>
            )}
          </div>
        </div>
      </div>
    </footer>
  )
}
